export const isExitIntentAllowedAtPath = (urlPath: string) => {
  // return false if the url path is not provided
  if (!urlPath) return false

  // return false if the pagePath matches any of the ignored paths
  const ignorePaths: string[] = ['/request-demo', '/request-demo-confirmed']
  const normalizedPath = urlPath.split('?')[0].replace(/\/$/, '').toLowerCase()
  if (ignorePaths.some((ignorePath) => normalizedPath.endsWith(ignorePath))) {
    return false
  }

  return true
}
